import { navLinks } from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="bg-background-200/60 pt-14 text-foreground-700">
      <div className="container-site">
        <div className="grid gap-8 pb-12 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-eye-2-line text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-foreground-950">吃瓜直播</span>
                <span className="text-[10px] tracking-widest text-foreground-500">围观群众集合地</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed">
              蹲后续、催更、求指路一站式搞定的围观社区。热门事件入口清晰，脉络按时间线整理，后续更新提醒到位，跟紧大部队不迷路。
            </p>
            <div className="mt-5 flex gap-2">
              <span className="chip bg-background-50 text-foreground-700">围观指南</span>
              <span className="chip bg-background-50 text-foreground-700">文明发言</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">快速围观</h4>
            <ul className="mt-4 grid gap-2.5 text-sm">
              {navLinks.map((l) => (
                <li key={l.key}>
                  <a
                    href={`#${l.key}`}
                    className="inline-flex items-center gap-1.5 whitespace-nowrap transition-colors hover:text-primary-700"
                  >
                    <i className={`${l.icon} text-foreground-400`}></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">站内服务</h4>
            <ul className="mt-4 grid gap-2.5 text-sm">
              <li>
                <a href="#board" className="whitespace-nowrap transition-colors hover:text-primary-700">围观广场</a>
              </li>
              <li>
                <a href="#guide" className="whitespace-nowrap transition-colors hover:text-primary-700">蹲后续指南</a>
              </li>
              <li>
                <a href="#faq" className="whitespace-nowrap transition-colors hover:text-primary-700">常见问题</a>
              </li>
              <li>
                <a href="#subscribe" className="whitespace-nowrap transition-colors hover:text-primary-700">订阅更新提醒</a>
              </li>
            </ul>
            <div className="mt-5">
              <p className="text-sm font-medium text-foreground-800">意见反馈</p>
              <a
                href="mailto:hello@chiagualive.example"
                className="mt-1 inline-flex items-center gap-1.5 text-sm text-primary-700 hover:text-primary-800"
              >
                <i className="ri-mail-send-line"></i> hello@chiagualive.example
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-300/70">
        <div className="container-site flex flex-col items-center justify-between gap-2 py-5 text-xs text-foreground-500 sm:flex-row">
          <span>© {new Date().getFullYear()} 吃瓜直播 · 围观群众集合地</span>
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-verified-badge-line"></i> 本站内容仅作围观参考，请理性看待网络信息
          </span>
        </div>
      </div>
    </footer>
  );
}